module.exports = ".container {\n  padding: 40px 10px;\n  font-family: Lekton, sans-serif;\n  text-align: center;\n  font-size: 14px;\n  margin: 0 auto; }\n\n.gallery {\n  text-align: center; }\n\n.gallery img {\n    width: 90px;\n    margin-right: 10px; }\n\n.gallery img:last-child() {\n      margin-right: 0px; }\n\n@media (min-width: 768px) {\n  .container {\n    width: 740px; } }\n\n@media (min-width: 992px) {\n  .container {\n    width: 960px; } }\n\n@media (min-width: 1200px) {\n  .container {\n    width: 1160px; } }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/about/about.component.scss
// module id = ./src/app/about/about.component.scss
// module chunks = main